import {useTranslation} from 'react-i18next';
import {getDateFormat, tsGetYear} from '../../../../library/dates';
import {TMemberSubscription} from '../memberTicket.type';
import * as css from './MemberTicketHeader.css';

interface MemberTicketHeaderProps {
    subscription: TMemberSubscription;
}

/* Season name over the seasonal-subscription date range.
   Different years: years only. Same year: month and year. */
function MemberTicketHeader({subscription}: MemberTicketHeaderProps) {
    const {t} = useTranslation('eTicket');
    const {seasonStart, seasonEnd} = subscription;
    const format = seasonStart && seasonEnd && tsGetYear(seasonStart) !== tsGetYear(seasonEnd) ? 'YYYY' : 'MM.YYYY';
    const seasonRange = seasonStart && seasonEnd
        ? t('seasonalSubscriptionRange', {
            start: getDateFormat(seasonStart, format),
            end: getDateFormat(seasonEnd, format)
        })
        : undefined;

    return (
        <css.header data-cy="member-ticket-header">
            <css.title>{subscription.season || t('memberTicketLabel')}</css.title>
            {seasonRange && <css.subtitle>{seasonRange}</css.subtitle>}
        </css.header>
    );
}

export default MemberTicketHeader;
